import { render, staticRenderFns } from "./Activation.vue?vue&type=template&id=6aefa90e"
import script from "./Activation.vue?vue&type=script&lang=ts"
export * from "./Activation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports